export const SpeciesListSpeciesFields = {
    alternativeLatinName: "latinName",
    alternativeCommonName: "commonName",
};


